import { observable, computed, action, makeObservable } from 'mobx'
import Collection from './Collection'
import MonthlyResourceCellModel from '../Models/MonthlyResourceCellModel'

class MonthlyResourceCellCollection extends Collection {
    constructor() {
        super({
            collection: 'monthlyResourceCells',
            modelClass: MonthlyResourceCellModel,
        })
        this.addLookup('cellsByStatus', 'manyByKey', {
            key: (t) => t.status,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('cellsByProjectId', 'manyByKey', {
            key: (t) => t.projectId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('cellsByPhaseId', 'manyByKey', {
            key: (t) => t.phaseId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('cellsByStaffId', 'manyByKey', {
            key: (t) => t.staffId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('cellsByRoleId', 'manyByKey', {
            key: (t) => t.staffRoleId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('cellsByMonth', 'manyByKey', {
            key: (t) => t.month,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('cellsByType', 'manyByKey', {
            key: (t) => t.type,
            filter: (t) => !t.deletedAt,
        })
        makeObservable(this)
    }
    get cellsById() {
        return this.modelsById
    }
    get cells() {
        return this.models
    }
    @action.bound
    addCell(data, options) {
        return this.add(data, options)
    }
    @action.bound
    addCells(data, options) {
        return this.addMany(data, options)
    }
}

export default new MonthlyResourceCellCollection()
export const MonthlyResourceCellCollectionClass = MonthlyResourceCellCollection
